import React, { useState, useEffect } from "react";

const API_URL = "https://comoticket-production.up.railway.app/api";

export default function ResellersPage() {
  const [merchants, setMerchants] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(API_URL + "/public/merchants")
      .then(r => r.json())
      .then(data => { setMerchants(data); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div style={{minHeight:"100vh",background:"#0a0a0a",fontFamily:"'Inter',Arial,sans-serif",color:"white"}}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
      `}</style>

      <nav style={{position:"sticky",top:0,zIndex:100,background:"rgba(10,10,10,0.95)",backdropFilter:"blur(20px)",borderBottom:"1px solid rgba(255,255,255,0.06)",padding:"16px 40px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <a href="/events" style={{display:"flex",alignItems:"center",gap:10,textDecoration:"none"}}>
          <div style={{width:36,height:36,background:"#2563eb",borderRadius:10,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,fontWeight:800,color:"white"}}>C</div>
          <span style={{fontSize:18,fontWeight:800,letterSpacing:"-0.5px",color:"white"}}>ComoTicket</span>
        </a>
        <a href="/organisateur" style={{background:"#2563eb",color:"white",padding:"9px 20px",borderRadius:100,fontWeight:700,fontSize:13,textDecoration:"none"}}>Je suis organisateur</a>
      </nav>

      <div style={{maxWidth:900,margin:"0 auto",padding:"60px 40px"}}>
        <a href="/events" style={{color:"rgba(255,255,255,0.4)",fontSize:13,textDecoration:"none",display:"inline-block",marginBottom:24}}>&larr; Retour aux &eacute;v&eacute;nements</a>
        <h1 style={{fontSize:40,fontWeight:900,letterSpacing:"-1.5px",marginBottom:12}}>O&ugrave; acheter mon billet ?</h1>
        <p style={{fontSize:15,color:"rgba(255,255,255,0.5)",marginBottom:40,lineHeight:1.7}}>
          Tous nos billets sont vendus en cash par un r&eacute;seau de commer&ccedil;ants agr&eacute;&eacute;s &agrave; travers les Comores. Trouvez le point de vente le plus proche de vous.
        </p>

        {loading ? (
          <div style={{textAlign:"center",padding:60,color:"rgba(255,255,255,0.3)"}}>Chargement...</div>
        ) : merchants.length === 0 ? (
          <div style={{textAlign:"center",padding:60,color:"rgba(255,255,255,0.3)"}}>Aucun revendeur disponible pour le moment</div>
        ) : (
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:16}}>
            {merchants.map((m, i) => (
              <div key={i} style={{background:"#111",border:"1px solid rgba(255,255,255,0.06)",borderRadius:16,overflow:"hidden"}}>
                {m.photo_url ? (
                  <img src={m.photo_url} alt={m.shop_name || m.name} style={{width:"100%",height:180,objectFit:"cover"}} />
                ) : (
                  <div style={{width:"100%",height:180,background:"linear-gradient(135deg,#1a1a2e,#0f3460)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:48}}>&#127978;</div>
                )}
                <div style={{padding:18}}>
                  <div style={{fontSize:16,fontWeight:800,marginBottom:4}}>{m.shop_name || m.name}</div>
                  {m.shop_name && <div style={{fontSize:12,color:"rgba(255,255,255,0.4)",marginBottom:10}}>{m.name}</div>}
                  {m.phone && (
                    <div style={{fontSize:13,color:"#60a5fa",fontWeight:600,marginTop:10}}>&#128222; {m.phone}</div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        <div style={{marginTop:48,background:"#111",borderRadius:16,padding:28,border:"1px solid rgba(255,255,255,0.06)",textAlign:"center"}}>
          <div style={{fontSize:14,color:"rgba(255,255,255,0.5)",lineHeight:1.7}}>
            Vous &ecirc;tes commer&ccedil;ant et souhaitez devenir revendeur ComoTicket ?<br/>
            <a href="/devenir-revendeur" style={{color:"#60a5fa",fontWeight:700,textDecoration:"none"}}>Faire une demande &rarr;</a>
          </div>
        </div>
      </div>
    </div>
  );
}